export function thisYear(): number {
  return new Date().getFullYear();
}

export function decadeOf(year: number): number {
  return Math.floor(year / 10) * 10;
}

/** A 4-digit year out of a number or an attribute string, else null. */
export function parseYear(
  value: number | string | null | undefined,
): number | null {
  if (null == value || "" === value) {
    return null;
  }

  const year = Number(value);

  return Number.isInteger(year) ? year : null;
}
